import { createRoot, type Root } from "react-dom/client";
import type { ReactNode } from "react";

const roots = new WeakMap<Element | DocumentFragment, Root>();

export function render(
  node: ReactNode,
  container: Element | DocumentFragment
): void {
  let root = roots.get(container);
  if (!root) {
    root = createRoot(container);
    roots.set(container, root);
  }
  root.render(node);
}

export function unmountComponentAtNode(container: Element): boolean {
  const root = roots.get(container);
  if (!root) {
    return false;
  }
  root.unmount();
  roots.delete(container);
  return true;
}
